import { useState } from "react";
import { useEffect } from "react";

import { useMyContext } from "../../../../contexts/StateHolder";
import { trancuateDesc } from "../../../../scripts/utils";

import useWindowDimensions from "../../../WindowDimension";

import classes from "./VideoDetailDescription.module.css";

const VideoDetailDescription = (props) => {
	const { chosenItem } = useMyContext();
	const [text, setText] = useState(null);

	const windowDimension = useWindowDimensions();

	console.log("text", text);

	useEffect(() => {
		if (props?.desc || chosenItem?.itemDescription) {
			let textDescResult = props?.desc || chosenItem?.itemDescription;

			if (windowDimension.width >= 550) {
				if (props.sanitizeHTML) {
					textDescResult = textDescResult.replace(/<\/?[^>]+(>|$)/g, "");
				}
				textDescResult = trancuateDesc(textDescResult, props.size || 90);
			} else {
				if (props.sanitizeHTML) {
					textDescResult = textDescResult.replace(/<\/?[^>]+(>|$)/g, "");
				}
				textDescResult = trancuateDesc(textDescResult, props.mobileSize || 70);
			}
			setText(textDescResult);
		}
	}, [
		chosenItem,
		props.desc,
		props.size,
		windowDimension.width,
		props.mobileSize,
		props.sanitizeHTML,
	]);

	const renderItemDescription = () => {
		return (
			<div
				className={`${classes.itemDescription} font-300 ${props.extraClassName}`}
				dangerouslySetInnerHTML={{ __html: text }}
				style={props.color ? { color: props.color } : null}
			/>
		);
	};

	return renderItemDescription(props?.desc ? props?.desc : chosenItem?.description);
};

export default VideoDetailDescription;
